import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Customers from "./pages/Customers";
import Sales from "./pages/Sales";
import Inventory from "./pages/Inventory";
import Reports from "./pages/Reports";
import Pricing from "./pages/Pricing";
import Invoices from './pages/Invoices';
import Editinvoice from './pages/Editinvoice';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/products" element={<Products />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/pricing/" element={<Pricing />} />
          <Route path="/invoices/" element={<Invoices />} />
          <Route path="/editinvoice/" element={<Editinvoice />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;